export default "__VITE_ASSET__yU0ZZAl4__"